export var FrStatusEnum;
(function (FrStatusEnum) {
    FrStatusEnum["UNVERIFIED"] = "unverified";
    FrStatusEnum["VERIFIED"] = "verified";
    FrStatusEnum["TEMPORARY_REJECTED"] = "temporary_rejected";
    FrStatusEnum["REJECTED"] = "rejected";
    FrStatusEnum["PENDING"] = "pending";
})(FrStatusEnum || (FrStatusEnum = {}));
//# sourceMappingURL=fr-status.enum.js.map